import React from 'react';
import { connect } from 'react-redux';
import { updateInfluencer } from '../actions';
import ReactDOMServer from 'react-dom/server';

import DropzoneComponent from 'react-dropzone-component';
import 'react-dropzone-component-css';
import 'dropzone-css';
import Config from '../Config';

import css from './avatar-uploader.css';
import MdAdd from 'react-icons/lib/md/add';

const requestHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
});

const dropZoneComponentConfig = (id) => ({
  iconFiletypes: ['.jpg', '.jpeg', '.webm', '.png', '.gif'],
  showFiletypeIcon: true,
});

const dropZoneMessage = (props) => (
  ReactDOMServer.renderToStaticMarkup(
    <span className={css.addMessage}>
      <MdAdd />
    </span>
  )
);

class AvatarUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { processing: false, progress: 0 };
  }

  eventHandlers = () => ({
    error: function (file) {
      // TODO: Send action to update reducer with error.
    },
  });

  dropZoneConfig = () => {
    const _component = this;

    return {
      autoProcessQueue: false,
      dictDefaultMessage: dropZoneMessage(),
      createImageThumbnails: false,
      init: function () {

        this.on('addedfile', function (file) {

          let _this = this;
          const fetchOptions = {
            method: 'GET',
            headers: new Headers(requestHeaders()),
          };

          fetch(`${Config.apiBase}/images/cache/presign`, fetchOptions).then((response) => {
            response.json().then(json => {
              // Add formdata to param options
              // https://github.com/enyo/dropzone/blob/master/src/dropzone.coffee#L1222
              Object.assign(_this.options.params, json.fields);

              // Update url to s3 endpoint
              _this.options.url = json.url;

              // Set processing flag
              _component.setState({ processing: true });
              _this.processQueue();
            });
          });
        });

        this.on('success', function (file) {
          const image = {
            id: this.options.params.key.match(/cache\/(.+)/)[1], // we have to remove the prefix part
            storage: 'cache',
            metadata: {
              size:      file.size,
              filename:  file.name.match(/[^\/\\]+$/)[0], // IE returns full path
              mime_type: file.type,
            },
          };

          _component.setState({ processing: false });

          _component.props.onComplete(JSON.stringify(image));
        });
      },
    };
  };

  render() {
    return (
      <div>
        <DropzoneComponent
          config={dropZoneComponentConfig(this.props.id)}
          action="upload"
          djsConfig={this.dropZoneConfig()}
          eventHandlers={this.eventHandlers()}
        />
      </div>
    );
  }
}

export default connect()(AvatarUploader);



/** WEBPACK FOOTER **
 ** ./components/AvatarUploader.js
 **/